export default {
    frontPage: 1,
    frontMobilePage: 4,
    inSearchResults: 5,
    searchResult: 2,
    pageLocationId: 3,
    adList: {}
}